export class Slider {
  /** @var {HTMLDivElement|null} element */
  element = null;

  constructor(element = null) {
    this.setElement(element);
  }

  /**
   * @param {HTMLDivElement | null} element
   */
  setElement = (element) => {
    if (element === this.element) return
    if (this.element) {
      this.element.removeEventListener("scroll", this.updatePosition)
    }
    this.element = element;
    if (this.element) {
      this.updatePosition();
      this.element.addEventListener("scroll", this.updatePosition, {passive: true})
    }
  }


  slideLeft(slides = 5) {
    /** @var {HTMLElement} */
    const firstChild = this.element.firstElementChild;
    const itemWidth = firstChild.offsetWidth;

    this.element.scrollTo({left: (this.element.scrollLeft - itemWidth * slides), behavior: 'smooth'});
  }

  slideRight(slides = 5) {
    /** @var {HTMLElement} */
    const firstChild = this.element.firstElementChild;
    const itemWidth = firstChild.offsetWidth;

    this.element.scrollTo({left: (this.element.scrollLeft + itemWidth * slides), behavior: 'smooth'});
  }

  updatePosition = () => {
    if (this.element.scrollLeft < 1) {
      this.element.classList.add("-start")
    } else {
      this.element.classList.remove("-start")
    }

    if (this.element.scrollLeft >= (this.element.scrollWidth - this.element.clientWidth - 1)) {
      this.element.classList.add("-end")
    } else {
      this.element.classList.remove("-end")
    }
  }
}
